export var FINITE_POSITIVE_INTEGER = /^[1-9]\d*$/;

/**
 * @private
 *
 * @constant {RegExp} FUNCTION_NAME_REGEXP
 */
export var FUNCTION_NAME_REGEXP = /^\s*function\s+([^\(\s]*)\s*/;

/**
 * @private
 *
 * @constant {Array<Object>} GOTCHA_OBJECT_CLASSES
 */
export var GOTCHA_OBJECT_CLASSES = [Boolean, Date, Number, RegExp, String];

/**
 * @private
 *
 * @constant {number} INFINITY
 * @default
 */
export var INFINITY = 1 / 0;

/**
 * @private
 *
 * @constant {string} INVALID_FIRST_PARAMETER_ERROR
 * @default
 */
export var INVALID_FIRST_PARAMETER_ERROR = 'You must pass either a function or an object of options as the first parameter to moize.';

/**
 * @private
 *
 * @constant {string} INVALID_PROMISE_LIBRARY_ERROR
 * @default
 */
export var INVALID_PROMISE_LIBRARY_ERROR = 'The promiseLibrary passed must either be a function or an object with the resolve / reject methods.';

/**
 * @private
 *
 * @constant {function|undefined} NATIVE_PROMISE
 */
export var NATIVE_PROMISE = typeof Promise === 'function' ? Promise : undefined;

/**
 * @private
 *
 * @constant {Object} DEFAULT_OPTIONS
 */
export var DEFAULT_OPTIONS = {
  equals: null,
  isPromise: false,
  isReact: false,
  maxAge: INFINITY,
  maxArgs: INFINITY,
  maxSize: INFINITY,
  promiseLibrary: NATIVE_PROMISE,
  serialize: false,
  serializeFunctions: false,
  serializer: null,
  transformArgs: null,
  updateExpire: false
};

/**
 * @private
 *
 * @constant {Array<string>} STATIC_PROPERTIES_TO_PASS
 */
export var STATIC_PROPERTIES_TO_PASS = ['contextTypes', 'defaultProps', 'propTypes'];


//////////////////
// WEBPACK FOOTER
// ./~/filtermatrix/~/moize/es/constants.js
// module id = 492
// module chunks = 0